export default "__VITE_ASSET__BaaJXhFX__"